<template>
  <div v-if="!!activity">
    <h2 class="mt-5 mb-10">
      <span ref="title" class="title pl-6 ml-n6 pb-1" style="border-bottom: #ffca37 2px solid;">
        {{ activity.name || 'Aktivität' }}
      </span>
    </h2>
    <v-form>
      <v-row class="justify-center">
        <v-menu v-if="isOwn" offset-y max-height="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="pr-5 gelb white--text mb-5">
              <v-icon class="mr-2">mdi-lightbulb-on</v-icon>
              Vorlage auswählen
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-for="(item, index) in activity_options" :key="item.name+''+index" @click="()=>onLoadVorlage(item)">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <p v-else>
          Diese Team-Aktivität kann nicht bearbeitet werden.
        </p>
      </v-row>

      <!-- NAME der AKTIVITÄT-->
      <v-text-field :disabled="!isOwn" v-model="activity.name" ref="tf_name" label="Name der Aktivität" prepend-icon="mdi-flag"
                    append-outer-icon="mdi-help-circle-outline" @click:append-outer="onHelpName">
      </v-text-field>

      <!-- MESSUNG-->
      <v-select :disabled="!isOwn" v-model="type" label="Messung" prepend-icon="mdi-counter" :items="type_options"
                append-outer-icon="mdi-help-circle-outline" @click:append-outer="onHelpMessung">
      </v-select>

      <!-- EINHEIT-->
      <v-combobox :disabled="!isOwn" v-model="unit" v-if="isNumeric" label="Einheit" prepend-icon="mdi-ruler-square"
                      :items="unit_options" append-outer-icon="mdi-help-circle-outline"
                      @click:append-outer="onHelpUnit" :search-input.sync="einheitInput">
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <p>Die Einheit "<strong>{{ einheitInput }}</strong>" existiert noch nicht.</p><p>Drücke <kbd>Enter</kbd> um sie zu erzeugen.</p>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-combobox>

      <!-- WENIGER ist BESSER-->
      <v-checkbox :disabled="!isOwn" v-model="activity.lessIsBetter" v-if="isNumeric" label="Weniger ist besser"></v-checkbox>

      <!-- ZIEL-->
      <v-row v-if="isNumeric" class="">
        <v-col cols="6">
          <v-select :disabled="!isOwn" label="Zieldefinition"  v-model="activity.freq" :items="freq_options"
                    append-outer-icon="mdi-help-circle-outline" @click:append-outer="onHelpFreq">
          </v-select>
        </v-col>
        <v-col cols="6">
          <v-text-field :disabled="!isOwn" label="Maximalwert"  v-model="activity.max" type="number"
                        append-outer-icon="mdi-help-circle-outline" @click:append-outer="onHelpMinMax">
          </v-text-field>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-select :disabled="!isOwn" class="ml-3 mr-3" label="Zieldefinition" prepend-icon="mdi-update" v-model="activity.freq" :items="freq_options"
                  append-outer-icon="mdi-help-circle-outline" @click:append-outer="onHelpFreq">
        </v-select>
      </v-row>
      <v-row v-if="isNumeric || (isBool && activity.freq==='pro Woche')">
        <v-col :cols="6">
          <div  >
            <span class="body-2 font-weight-light mr-1">Mein Ziel</span><br>
            <span class="display-3 font-weight-light mr-2" v-text="currentTarget" ></span>
            <span class="body-2" v-text="unitPerPeriod" v-if="!useTextField"/>
          </div>
        </v-col>
        <v-col :cols="6" class="pl-0 mt-0" v-if="isDirector || (!isTeamMember && (!currentTargets || !currentTargets.hasOwnProperty(activity.id)))">
          <div v-if="useTextField">
            <v-btn icon @click="useTextField=!useTextField">
              <v-icon>mdi-form-textbox</v-icon>
            </v-btn>
            <v-text-field :disabled="!isOwn" dense v-model="activity.target" style="max-width: 100px;" class="ml-auto mr-8"
                :label="unitPerPeriod">
            </v-text-field>
          </div>
          <div v-else>
            <v-btn icon @click="useTextField=!useTextField">
              <v-icon>mdi-form-textbox</v-icon>
            </v-btn>
            <v-slider
                :disabled="!isOwn"
                v-model="activity.target"
                color="gelb"
                track-color="grey"
                always-dirty
                :min="isBool ? 1 : activity.min"
                :max="isBool ? 7 : activity.max">
  <!--            <template v-slot:prepend>-->
  <!--              <v-icon @click="useTextField=true">-->
  <!--                mdi-form-textbox-->
  <!--              </v-icon>-->
  <!--            </template>-->
              <template v-slot:append>
                <v-icon @click="onHelpZiel">
                  mdi-help-circle-outline
                </v-icon>
              </template>
            </v-slider>
          </div>
        </v-col>
        <v-col :cols="6" class="pl-0 mt-0" v-else>
          Kann über <v-icon>mdi-bullseye-arrow</v-icon> Ziele eingestellt werden.
        </v-col>
      </v-row>

      <!-- JA/NEIN TEXT -->
      <template v-if="isBool">
        <v-text-field :disabled="!isOwn" label="Ja-Text" prepend-icon="mdi-thumb-up-outline" v-model="activity.positiv"
                      append-outer-icon="mdi-help-circle-outline" @click:append-outer="onHelpJaNeinText">
        </v-text-field>
        <v-text-field :disabled="!isOwn" label="Nein-Text" prepend-icon="mdi-thumb-down-outline" v-model="activity.negativ"
                      append-outer-icon="mdi-help-circle-outline" @click:append-outer="onHelpJaNeinText">
        </v-text-field>
      </template>

      <!-- Tägliche EINGABE oder Wochentag -->
      <v-select :disabled="!isOwn" v-if="isWeekly" label="Eingabe" prepend-icon="mdi-calendar" v-model="input" :items="input_options"
                append-outer-icon="mdi-help-circle-outline" @click:append-outer="onHelpEingabe">
      </v-select>

      <!-- WICHTIGKEIT -->
      <v-row>
        <div class="mt-2 ml-3">Wichtigkeit</div>
        <v-rating :readonly="!isOwn" class="my-auto mx-auto" v-model="activity.weight" color="gelb" size="40"></v-rating>
        <v-btn icon class="mr-2 mt-1" @click="onHelpWeight">
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
      </v-row>

      <!-- PRIVAT-->
      <v-checkbox v-if="isDirector" v-model="activity.private" label="Privat"></v-checkbox>

      <!-- STRÄHNE -->
      <v-checkbox v-model="activity.challenge" v-if="isDaily || isWeekly && currentTarget>=5" label="Challenge"></v-checkbox>

    </v-form>
    <v-btn class="mt-3 mx-auto d-flex gelb white--text" @click="onClose">{{isOwn ? "OK" : "Schließen"}}</v-btn>
  </div>
</template>

<script>
import Lib from "@/components/ActivityLibrary";
import Kinds from "@/components/Kinds";
import {Ziele} from "@/components/Ziele";

export default {
  name: "ActivityEditor",
  props: {
    'bereich': Object,
    'targets': Object,
  },
  data() {
    return {
      useTextField:false,
      template: undefined,
      freq_options: [Lib.FREQ_DAILY, Lib.FREQ_WEEKLY, Lib.FREQ_MONTHLY, Lib.FREQ_QUARTERLY, Lib.FREQ_HALFYEARLY, Lib.FREQ_YEARLY],
      type_options: [Lib.TYPE_NUMERIC, Lib.TYPE_BOOL],
      input_options: [Lib.INPUT_DAILY, Lib.INPUT_MO, Lib.INPUT_DI, Lib.INPUT_MI, Lib.INPUT_DO, Lib.INPUT_FR, Lib.INPUT_SA, Lib.INPUT_SO],
      unit_options: [], // <-- initialized from lib in mounted!
      activity_options: [],
      type: undefined,
      unit: undefined,
      do_not_save: false,
      input: undefined,
      einheitInput: undefined,
      isOwn: true,
      email: undefined,
      currentTargets:undefined,
    }
  },
  mounted() {
    // console.log("mounted!")
    this.email=this.$app.user.email;
    this.activity_options = [...(Lib.Activities[this.bereich.bid] || [])].sort((a, b) => (a.name > b.name) ? 1 : -1);
    this.unit_options = [...Lib.Units];
    this.currentTargets=new Ziele(this.targets).getCurrentTargets();
    this.load();
  },
  methods: {
    async load() {
      var obj = await this.$backend.get_object(Kinds.KIND_ACTIVITY, this.activity.id);
      if (obj) {
        this.do_not_save = true;
        Object.assign(this.activity, obj);
        this.update_local_variables();
        this.do_not_save = false;
      }
    },
    onLoadVorlage(vorlage) {
      this.$set(this.activity, 'name', vorlage.name);
      this.$set(this.activity, 'type', vorlage.type);
      this.type = vorlage.type;
      this.$set(this.activity, 'freq', vorlage.freq);
      this.$set(this.activity, 'input', vorlage.input??Lib.INPUT_DAILY);
      this.$set(this.activity, 'unit', vorlage.unit);
      if (vorlage.unit && this.unit_options.filter(x => x === vorlage.unit).length == 0)
        this.unit_options.push(vorlage.unit)
      this.unit = vorlage.unit;
      this.$set(this.activity, 'min', vorlage.min);
      this.$set(this.activity, 'max', vorlage.max);
      this.$set(this.activity, 'target', vorlage.target);
      this.$set(this.activity, 'positiv', vorlage.positiv);
      this.$set(this.activity, 'negativ', vorlage.negativ);
      this.$set(this.activity, 'less_is_better', vorlage.less_is_better);
      this.$set(this.activity, 'absolute', vorlage.absolute);
      this.activity.weight=5;
    },
    onClose(){
      if (this.isOwn)
        this.$backend.set_object(Kinds.KIND_ACTIVITY, this.activity.id, this.activity);
      this.$emit('close');
    },
    onHelpName() {
      this.$events.$emit("ask", {
        title: 'Name der Aktivität', yes_button: 'OK',
        question: 'Du kannst deine Aktivitäten benennen wie du willst. Vergib am besten einen kurzen treffenden Namen, ' +
            'denn unter dieser Bezeichnung scheinen die Messdaten dann im Dashboard auf.',
      });
    },
    onHelpFreq() {
      this.$events.$emit("ask", {
        title: 'Messfrequenz', yes_button: 'OK',
        question: 'Hier bestimmst du, ob das Ziel pro Woche oder pro Tag definiert sein soll. Das hängt ganz davon ab, ' +
            'wie regelmäßig du die Aktivität ausführen willst. <br><br>' +
            'Du hast hier die Möglichkeit selbst zu entscheiden, was für diese Aktivität sinnvoller ist.<br><br>' +
            '"pro Tag": Du möchtest die Aktivität jeden Tag ausführen um eine Gewohnheit aufzubauen.<br><br>' +
            '"pro Woche": Du möchtest die Aktivität mindestens einmal in der Woche ausführen.'
      });
    },
    onHelpMessung() {
      this.$events.$emit("ask", {
        title: 'Messung', yes_button: 'OK',
        question: 'Anzahl:<br><br> ' +
            'Es wird gemessen wie oft du die Aktivität ausgeführt hast oder wie viele Einheiten ' +
            '(z.B. Stunden, Kilometer, etc.) bei der Durchführung der Aktivität angefallen sind. <br><br>' +
            'Ja/Nein:<br><br>' +
            'Es wird lediglich getrackt, <i>ob</i> du die Aktivität ausgeführt hast oder nicht, oder ob du ' +
            'auf eine Angewohnheit, die du loswerden willst, verzichten konntest oder nicht.'
      });
    },
    onHelpUnit() {
      this.$events.$emit("ask", {
        title: 'Einheit', yes_button: 'OK',
        question: 'Wähle hier die zur Aktivität und Messung passende Einheit, z.B. "km" für die Aktivität "Laufen". Wenn ' +
            'du keine passende Einheit ' +
            'in der Liste findest, kannst du selbst eine definieren, z.B. "Posts" für die Aktivität "Bloggen". ' +
            '<br><br> Die Einheit ist wichtig, denn sie wird im Dashboard angezeigt.'
      });
    },
    onHelpMinMax() {
      this.$events.$emit("ask", {
        title: 'Wertebereich: Maximum', yes_button: 'OK',
        question: 'Wähle hier einen sinnvollen Maximalwert für diese Aktivität.' +
            '<br><br>Damit die Eingabe leicht von der Hand geht, sollte der Maximalwert etwas höher liegen, ' +
            'als was du realistischer Weise schaffen kannst, aber nicht viel mehr.'
      });
    },
    onHelpZiel() {
      this.$events.$emit("ask", {
        title: 'Mein Ziel', yes_button: 'OK',
        question: 'Setze dir ein realistisch erreichbares Ziel.<br><br>' +
            'Du wirst dein Ziel manchmal übertreffen und manchmal auch nicht. Wie gut du deine Ziele erreichst ' +
            'zeigt dir das Dashboard und der aus deiner Performance errechnete persönliche Index. Die Erinnerungsfunktion ' +
            'hilft dir außerdem nachhaltige Gewohnheiten aufzubauen.'
      });
    },
    onHelpWeight() {
      this.$events.$emit("ask", {
        title: 'Wichtigkeit', yes_button: 'OK',
        question: 'Hier kannst du festlegen, mit welchem Gewicht diese Aktivität in die Indexberechnung eingeht.'
      });
    },
    onHelpJaNeinText() {
      this.$events.$emit("ask", {
        title: 'Ja/Nein Texte', yes_button: 'OK',
        question: 'Der Ja- und der Nein-Text werden für die Beschriftung der Eingabebuttons benötigt, wenn du später ' +
            'deine Performance trackst. Bei Zielen, wo es positiv ist etwas nicht zu machen (wie z.B. "Nicht Rauchen"), ' +
            'könnte es zu Verwirrung kommen, wenn der Text des Ja-Buttons nicht eindeutig klarstellt, ob dieser nun bedeutet, ' +
            'dass man es geschafft hat zu verzichten oder ob man doch geraucht hat. Wähle daher eine eindeutige Beschriftung, ' +
            'damit der Ja-Text das positive Ergebnis darstellt.',
      });
    },
    onHelpEingabe() {
      this.$events.$emit("ask", {
        title: 'Eingabe', yes_button: 'OK',
        question: 'Wenn du dir ein Wochenziel gesetzt hast, kannst du hier entscheiden, ob du täglich deinen Fortschritt ' +
            'eingeben willst, oder einmal pro Woche an einem Wochentag deiner Wahl den Gesamtwert für die Woche eingeben willst.<br><br>' +
            'Wählst du hier z.B. "am Samstag" so wirst du an den anderen Wochentagen nicht zur Eingabe aufgefordert. ',
      });
    },
    onHelpWenigerIstBesser() {
      this.$events.$emit("ask", {
        title: 'Weniger ist besser', yes_button: 'OK',
        question: 'Dieses Hakerl wirst du selten brauchen. Doch für bestimmte Werte - wie z.B. die Anzahl der gerauchten Zigaretten ' +
            'gilt, dass ein niederer Wert besser als ein höherer ist.',
      });
    },
    onHelpZielIstAbsolut() {
      this.$events.$emit("ask", {
        title: 'Ziel ist absolut', yes_button: 'OK',
        question: 'Dieses Hakerl brauchen wir für Werte, die nicht "pro Tag" oder "pro Woche" zu verstehen sind sondern als sich ' +
            'ändernder Absolutwert. Ein Beispiel wäre der Blutdruck.',
      });
    },
    update_local_variables() {
      var n = this.activity;
      if (!n)
        return;
      this.type = n.type;
      if (n.unit && this.unit_options.filter(x => x === n.unit).length == 0)
        this.unit_options.push(n.unit)
      this.unit = n.unit;
      if (!n.weight)
        n.weight=5;
      this.input=n.input??Lib.INPUT_DAILY;
      this.isOwn=(n.__owner__ === this.email);
    },
  },
  computed: {
    currentTarget() {
      if (this.isTeamMember || this.isDirector || !this.currentTargets || !this.currentTargets.hasOwnProperty(this.activity.id))
        return this.activity.target || 0;
      return this.currentTargets[this.activity.id];
    },
    isDirector() {
      return this.$app.isDirector;
    },
    isTeamMember() {
      return this.$app.isTeamMember;
    },
    activity() {
      var bereich = this.bereich;
      if (!bereich || bereich.index === -1 || bereich.index === undefined)
        return {name: 'no activity selected'};
      return bereich.activities[bereich.index];
    },
    isNumeric() {
      return this.type === Lib.TYPE_NUMERIC;
    },
    isBool() {
      return this.type === Lib.TYPE_BOOL;
    },
    activity_index() {
      return this.bereich.index;
    },
    unitPerPeriod() {
      if (this.activity.absolute)
        return "" + (this.activity.unit || "")
      var periode = "Tag";
      if (this.activity.freq)
        periode = this.activity.freq.replace("pro ", "");
      var unit = this.isBool ? "mal" : (this.activity.unit || " ")
      return "" + unit + " pro " + periode;
    },
    isWeekly() {
      return (this.activity.freq===Lib.FREQ_WEEKLY);
    },
    isDaily() {
      return (this.activity.freq===Lib.FREQ_DAILY);
    }
  },
  watch: {
    bereich: {
      immediate: true,
      handler(n) {
        console.log("Bereich changed", n)
        var bereich = this.bereich;
        console.debug({bereich})
        this.activity_options = [...(Lib.Activities[this.bereich.bid] || []).map(x => x.name)];
      }
    },
    type(n) {
      this.activity.type = n;
      if (this.activity.type === Lib.TYPE_BOOL) {
        this.activity.positiv ||= "Geschafft";
        this.activity.negativ ||= "Nicht geschafft";
      }
    },
    unit(n) {
      this.activity.unit = n;
    },
    input(n) {
      this.activity.input=n;
    },
    activity_index() {
      this.update_local_variables();
      this.$nextTick(()=>{
        this.$refs.tf_name.focus();
        this.$vuetify.goTo(this.$refs.title);
      });
    },
  }
}
</script>

<style scoped>

</style>